import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { countriesDB } from './shared/tables/countries';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl= "http://13.127.206.22:3000/v1/country";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
  getCountries(): Observable<countriesDB[]> {
    return this.http.get<countriesDB[]>(apiUrl)
      .pipe(
        tap(countries => console.log('fetched countries')),
        catchError(this.handleError('getCountries', []))
      );
  }
  addProduct(country: countriesDB): Observable<countriesDB> {
    return this.http.post<countriesDB>(apiUrl, country, httpOptions).pipe(
      tap((prod: countriesDB) => console.log(`added Country`)),
      catchError(this.handleError<countriesDB>('addProduct'))
    );
  }
  updateProduct(id: any, product: countriesDB): Observable<any> {
    const url = `${apiUrl}/${id}`;
    return this.http.put(url, product, httpOptions).pipe(
      tap(_ => console.log(`updated product id=${id}`)),
      catchError(this.handleError<any>('updateProduct'))
    );
  }
  deleteProduct(id: any): Observable<countriesDB> {
    const url = `${apiUrl}/${id}`;
    return this.http.delete<countriesDB>(url, httpOptions).pipe(
      tap(_ => console.log(`deleted product id=${id}`)),
      catchError(this.handleError<countriesDB>('deleteProduct'))
    );
  }
  
}
